<template>
    <div id="disassociate-confirmation" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Unlink</h5>
                </div>
                <div class="modal-body">
                    <p v-html="message"></p>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-danger" @click="disassociateDocument()">Unlink</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
        return {
            url: null,
            ancestorId: null,
            message: null
        }
    },
    methods: {
        show: function (url, ancestorId, message) {
            this.url = url;
            this.ancestorId = ancestorId;
            this.message = message;
            $('#disassociate-confirmation').modal('show');
        },
        disassociateDocument: function () {
            axios.post(this.url, {
                ancestorId: this.ancestorId
            })
            .then(response => {
                // nothing to do; server side event will cause refresh
            })
            .catch(error => {
                let message = error.response.data.message;
                toastr['error'](message, 'Error', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            });
            
            $('#disassociate-confirmation').modal('hide');            
        }
    },
    created() {
        eventHub.$on('show-disassociate-confirmation', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-disassociate-confirmation');
    },     
}
</script>

<style scoped>

</style>